import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map, mergeMap } from 'rxjs/operators';
import {
  contenidoLoaded,
  getContenido,
  getContenidoFailure,
} from 'src/app/store/actions/content.action';
import { ContenidoDePagos } from 'src/app/pago/models/ContenidoDePagos.model';
import { SuraLoadingService } from '@segurosvoluntarios_vel/commons-services';
import { LoadingTag } from 'src/app/pago/enums/LoadingTag.enum';
import { ContenidoPagosService } from 'src/app/pago/services/contenido-pagos/contenido-pagos.service';

@Injectable()
export class ContenidoEffect {
  constructor(
    private actions$: Actions,
    private contenidoPagosService: ContenidoPagosService,
    public suraLoadingService: SuraLoadingService
  ) {}

  getContenido$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(getContenido),
      mergeMap(action => {
        this.suraLoadingService.addLoadingTag(LoadingTag.CARGANDO_CONTENIDO);
        return this.contenidoPagosService
          .getContenido(action.tenant, action.producto)
          .pipe(
            map((contenido: ContenidoDePagos) => {
              return contenidoLoaded({
                contenido,
              });
            }),
            catchError(error =>
              of(getContenidoFailure({ errorMessage: error.message }))
            ),
            finalize(() => {
              this.suraLoadingService.removeLoadingTag(
                LoadingTag.CARGANDO_CONTENIDO
              );
            })
          );
      })
    )
  );
}
